/**
 * When the running PixelatedWave finishes (a `performance.now()` time), so
 * PageMotion can start cards and rows as the wave clears rather than under
 * it. 0 when no wave has run. Only one wave runs at a time.
 */
let waveEndsAt = 0

export const setWaveEnd = (at: number): void => {
  waveEndsAt = at
}

export const getWaveEnd = (): number => waveEndsAt
